import React from 'react';

import Hero from 'components/hero';
import BenefitArticle from 'components/benefit-article';

import ImageUrl1 from 'svg/illustrations/undraw_growth_analytics_8btt.svg';
import ImageUrl2 from 'svg/illustrations/undraw_friends_online_klj6.svg';
import ImageUrl3 from 'svg/illustrations/undraw_treasure_of9i.svg';
import ImageUrl4 from 'svg/illustrations/undraw_personal_information_962o.svg';
import ImageUrl5 from 'svg/illustrations/undraw_press_play_bx2d.svg';
import ImageUrl6 from 'svg/illustrations/undraw_checking_boxes_2ibd.svg';
import ImageUrl7 from 'svg/illustrations/undraw_feedback_h2ft.svg';
import ImageUrl8 from 'svg/illustrations/undraw_performance_overview_p9bm.svg';
import ImageUrl9 from 'svg/illustrations/undraw_new_ideas_jdea.svg';

const WorkerBenefits = () => {
  return (
    <Hero layout="vertical" className="bg-grey">
      <h2>We have listed the unique benefits of using MyShifts</h2>
      <BenefitArticle
        title="You are in control of your rate of pay."
        image={ImageUrl1}
        isLeft
      >
        <p>
          You set your rate of pay when you register - and you can change this
          at any time. The employer pays you directly and makes all your PAYE
          payments for you.
        </p>
        <p>
          The money that you receive is your total net pay - nothing else to pay
          out, you complete a timesheet and get paid alongside all other workers
          at the service, where you complete your shift.
        </p>
      </BenefitArticle>
      <BenefitArticle
        title="You work directly for the employer."
        image={ImageUrl2}
      >
        <p>You are part of &apos;the team&apos;.</p>
        <p>
          They provide you with all the necessary equipment, training and
          support required to complete your tasks whilst working via MyShifts.
        </p>
        <p>
          They ensure you are paid your wages and any taxes or NI contributions
          are paid by them to HMRC.
        </p>
      </BenefitArticle>
      <BenefitArticle
        title="MyShifts is completely free of charge for Workers."
        image={ImageUrl3}
        isLeft
      >
        <p>
          Workers are able to register for free* and we guarantee there will
          never be any charges to you for being available and looking for work
          via MyShifts.
        </p>
        <p>
          MyShifts charge employers a small fee every time they want to view
          your details in full and see if they want to offer you a shift. This
          fee is considerably lower than traditional employment agencies charge.
        </p>
        <p>
          Due to UK Employment Regulations you will never be charged for
          registration with MyShifts
        </p>
      </BenefitArticle>
      <BenefitArticle title="You are 'free as a bird'." image={ImageUrl4}>
        <p>
          MyShifts is all about helping you get work. If being in control of
          when you work, how much you work for and who you work for is not for
          you that&apos;s fine and you decide to take on a permanent role and
          get hired by an employer after working via MyShifts, that&apos;s
          fantastic.
        </p>
        <p>
          In contrast, traditional employment agency contracts can lock you in
          to only working with them.
        </p>
        <p>
          Agencies can also withhold your completed training certificates, completed when
          you get work via them, to stop you going elsewhere.
        </p>
      </BenefitArticle>
      <BenefitArticle
        title="MyLearning is an online platform that organises your learning and
        development needs and allows you to access your learning whenever you
        like, on any device you like."
        image={ImageUrl5}
        isLeft
      >
        <p>
          MyLearning is tailored for the Health and Social Care sector and
          provides over 85 e-learning courses as standard.
        </p>
        <p>
          For workers who gain employment via a MyShifts, the MyLearning
          platform is free and will allow you to share in detail all your
          training with potential employers enabling even more confidence in
          your ability and to reassure them that you are up to date with all the
          Mandatory Learning requirements and safe to work.
        </p>
        <p>
          So when you register with MyShifts and receive your first confirmed
          placement we will automatically enrol you onto our MyLearning
          platform.
        </p>
        <p>
          You will receive an email with details on how to register on the
          platform and away you go.
        </p>
        <p>Happy Learning!</p>
      </BenefitArticle>
      <BenefitArticle
        title="We give you all the info to decide on which MyShifts to accept."
        image={ImageUrl6}
      >
        <p>
          Traditional Employment Agencies may not give you all the information you need
          to decide to accept a shift or not.
        </p>
        <p>Each work opportunity on MyShifts includes the following info:-</p>
        <ul>
          <li>Type of service being provided.</li>
          <li>Employer / Organisation&apos;s CQC rating.</li>
          <li>Key skills required from you.</li>
          <li>Public transport nearby.</li>
          <li>Parking availability.</li>
          <li>Exact times of the shifts being requested.</li>
          <li>Rate of Pay the employer is prepared to pay you.</li>
        </ul>
        <p>
          This helps you choose to say YES or NO to the MyShifts work
          opportunity.
        </p>
      </BenefitArticle>
      <BenefitArticle
        title="MyFeedback enables both worker and employer to 'rate' each others performance."
        image={ImageUrl7}
        isLeft
      >
        <p>
          MyShifts believes performance improves and standards rise with
          positive and constructive feedback. Therefore, MyShifts allows both
          workers and employers to rate each other against a pre-defined scale
          on certain key indicators. We call this MyFeedback.
        </p>
        <p>These indicators are:-</p>
        <ol>
          <li>Teamwork</li>
          <li>Accuracy of MyShifts descriptions</li>
          <li>Leadership</li>
          <li>Recommend to a colleague</li>
          <li>Service user/Worker safety.</li>
        </ol>
        <p>
          This information does not identify personal data but simply the score
          for each indicator. This information is shared with both Worker and
          Employer when a match has been made using MyShifts. This helps in your
          decision about accepting a MyShift posting or not.
        </p>
      </BenefitArticle>
      <BenefitArticle
        title="MyShifts creates a level playing field."
        image={ImageUrl8}
      >
        <p>
          Every time an employer posts a MyShifts work opportunity, their
          requirements are automatically checked against each and every MyShifts
          registered worker to see if there is a &apos;match&apos;.
        </p>
        <p>
          If there is, then MyShifts will send an anonymous mini fact-sheet
          about you – the worker - to the potential employer. This mini fact-sheet
          does not identify you and is allocated a different ID Number each time
          you are matched for a MyShifts work opportunity.
        </p>
        <p>
          This ensures that all registered MyShifts Workers have equal
          opportunity of being &apos;matched&apos; as MyShifts randomised ID
          Numbers ensure that employers do not simply look for the same workers
          each time.
        </p>
        <p>
          If each MyShifts registered Worker keeps improving their &apos;Worker
          Rating&apos; this will also ensure improved visibility for all
          &apos;matching&apos; opportunities and the higher the worker rating is
          the higher they will appear on the list of matched workers.
        </p>
      </BenefitArticle>
      <BenefitArticle
        title="Join the WorkeR-evolution."
        image={ImageUrl9}
        isLeft
      >
        <p>
          Therefore, MyShifts is a completely new way of finding work. Because
          of this direct approach we feel it is like a revolution for the
          recruitment industry. Therefore, we want all the people who sign up to
          MyShifts to feel part of a wider team.
        </p>
        <p>
          We want to share our success with all Workers who regularly use
          MyShifts. We have a range of perks and benefits that will reward you
          when you have completed a number of MyShifts.
        </p>
        <p>
          Watch out for our constantly updating list of all the perks and
          benefits available to you once you register with MyShifts.
        </p>
        <p>
          <strong>
            You have now heard a lot about MyShifts and now is the time we hear
            a bit more about you!
          </strong>
        </p>
      </BenefitArticle>
    </Hero>
  );
};

export default WorkerBenefits;
